import { Link } from "react-router-dom";
import { ClockIcon } from "lucide-react";

import { useLicense } from "@/api/license";
import { useAuthStore } from "@/store/auth";
import { licenseBannerState } from "./licenseBanner";

/**
 * Top-of-screen license-state banner. The shown message is derived from the
 * COMPUTED lifecycle + is_trial + tier (see ./licenseBanner) — never the raw
 * `status` column — so an enterprise license in its grace period shows a
 * "grace period — renew" message (matching the backend alert), not a bogus
 * "trial expired". Non-admins still see the banner; only admins get the CTA.
 */
export function TrialBanner() {
  const { data: license } = useLicense();
  const role = useAuthStore((s) => s.user?.role);

  const banner = licenseBannerState(license);
  if (!banner) return null;

  const tone =
    banner.tone === "red"
      ? "bg-red-500/10 border-red-500/40 text-red-700 dark:text-red-300"
      : "bg-amber-500/10 border-amber-500/40 text-amber-800 dark:text-amber-300";

  const msg = banner.msg;

  return (
    <div
      className={`flex items-center justify-between gap-2 border-b px-4 py-2 text-xs ${tone}`}
    >
      <span className="flex items-center gap-2">
        <ClockIcon className="h-3.5 w-3.5" />
        {msg}
      </span>
      {role === "admin" && (
        <Link
          to="/license"
          className="font-semibold underline-offset-2 hover:underline"
        >
          View plan →
        </Link>
      )}
    </div>
  );
}
